import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ToastService {
    constructor() { }
    private emitChangeSource = new Subject<any>();
    changeEmitted$ = this.emitChangeSource.asObservable();
    notify(data) {
        this.emitChangeSource.next(data);
    }
}


// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/shared/toastservice.ts